import React from 'react';

interface SmartIconProps {
  className?: string;
}

const SmartIcon: React.FC<SmartIconProps> = ({ className }) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M2.04189 5.84575C2.38527 4.52309 3.57912 3.59961 4.94563 3.59961H7.0544C8.4209 3.59961 9.61478 4.52309 9.95816 5.84575L10.4254 7.64577C10.9187 9.54567 9.48464 11.3996 7.52174 11.3996H4.47832C2.51541 11.3996 1.08133 9.54567 1.57458 7.64577L2.04189 5.84575ZM3.43419 1.46794C3.23472 1.069 3.52481 0.599609 3.97084 0.599609H8.02922C8.4752 0.599609 8.7653 1.069 8.56586 1.46794L7.96586 2.66794C7.86422 2.87121 7.65644 2.99961 7.42922 2.99961H4.57084C4.34358 2.99961 4.13582 2.87121 4.03419 2.66794L3.43419 1.46794Z"
        fill="#FFD039"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.22632 6.47083C4.22632 5.82139 4.75278 5.29492 5.40221 5.29492H7.77365V6.30841H5.39314C5.30847 6.30841 5.23984 6.37705 5.23984 6.46177C5.23984 6.51973 5.27254 6.57271 5.32434 6.59875L7.13351 7.50727C7.52591 7.70431 7.77365 8.10589 7.77365 8.54503C7.77365 9.18637 7.25375 9.70627 6.61241 9.70627H4.22632V8.69275H6.60863C6.69227 8.69275 6.76013 8.62489 6.76013 8.54125C6.76013 8.48347 6.72725 8.43073 6.67535 8.40523L4.88427 7.52647C4.48154 7.32889 4.22632 6.91939 4.22632 6.47083Z"
        fill="#111111"
      />
    </svg>
  );
};

export default SmartIcon;